import Tasks from 'APP/Tasks';
import { ChatMessage } from 'STORE/Messages/Message/ChatMessage/ChatMessage';

export async function editMediaMessage(
  message: ChatMessage,
  comment: string,
  mustBeScheduled: boolean
): Promise<boolean> {
  if (!message.group) {
    return false;
  }

  const oldComment = message.payload.comment;
  message.payload.comment = comment;

  const canEdit = Tasks.messaging.canSendMessage({
    groupId: message.groupId,
    isCheckSlowMode: !mustBeScheduled,
    isNewMessage: false,
    payload: message.payload,
  });

  if (!canEdit.result) {
    message.payload.comment = oldComment;
    canEdit.error && Tasks.app.showToast(canEdit.error);
    return false;
  }

  if (mustBeScheduled) {
    return await Tasks.messaging.editScheduledMessage({
      message,
      date: new Date(message.serverTime),
    });
  }

  Tasks.messaging.editMessage(message);
  return true;
}
